import React, { useRef, useEffect, useState } from 'react'
import Btn from './btn'
import Menu from './menu'
import { localestr } from '../utils.js'
import icon from '../icons.svg';

function TablesTab({ userId, hall, setHall, tblClick, Data, Orders, Rights }) {
  const targetRef = useRef()
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  useEffect(() => {
    if (targetRef.current) {
      setDimensions({
        width: targetRef.current.offsetWidth,
        height: targetRef.current.offsetHeight
      });
    }
  }, []);

  let content = ''

  const setCurHall = (el) => {
    if (el.tables && el.tables.length) {
      let maxW = 1
      let maxH = 1
      const l = el.tables.length
      for (let i = 0; i < l; i++) {
        const tb = el.tables[i]
        const w = parseInt(tb.lefl) + parseInt(tb.width)
        if (w > maxW) maxW = w
        const h = parseInt(tb.top) + parseInt(tb.height)
        if (h > maxH) maxH = h
      }
      const kW = (dimensions.width - 5) / maxW
      const kH = (dimensions.height - 34) / maxH
      const kO = Math.min(kW, kH)
      content = el.tables.map((el, idx) => {
        const l = parseInt(el.lefl) * kO
        const t = parseInt(el.top) * kO
        const w = Math.max(0, (parseInt(el.width) * kO) - 4 - 16)
        let h = Math.max(0, (parseInt(el.height) * kO) - 4)
        if (h === 0) h = 32
        let p = Math.max((h - 24) / 2, 0) + 1

        let cantClick = false
        let br = ''
        let cap = ''
        let stl = { position: 'absolute', left: l + 'px', top: t + 'px', padding: p + 'px 8px' }
        let stl1 = { position: 'absolute', left: l + 'px', top: t + 'px', height: h + 'px' }
        let stl2 = { padding: p + 'px 8px' }
        let cls = ''
        let obj = { table: el }
        let obj2 = { table: el }
        let comm = null
        let ord_aut = []
        let r_c = 1
        let small_font = false
        let status = 0
        if (w) { stl.width = w + 'px'; stl2.width = w + 'px'; }

        const filter_date = new Date()
        filter_date.setHours(filter_date.getHours() + 2)
        const str_date = filter_date.toISOString()

        if (Orders) {
          const ord = Orders.filter(o => o.table && o.table.id === el.id && (o.date||str_date)<=str_date)
          let sum_aut = 0
          let cnt_aut = 0
          status = 1
          for (let i = 0; i < ord.length; i++) {
            if (ord[i].author.id === userId) {
              sum_aut += parseFloat(ord[i].sum)
              cnt_aut++
              ord_aut.push({ table: el, uid: ord[i].uid, id: ord[i].id || '*', sum: ord[i].sum.toFixed(2) })
              if (!ord[i].status) status = 0
            }
            else if (Rights.urAdmin || Rights.urOrder) {
              ord_aut.push({ table: el, uid: ord[i].uid, id: ord[i].id, sum: ord[i].sum.toFixed(2) })
              sum_aut += parseFloat(ord[i].sum)
            }
          }
          if (ord.length) {
            if (!ord_aut.length && !Rights.urTable) cantClick = true
            r_c = 2
            if (cnt_aut) {
              cap = sum_aut.toFixed(2)
              if (cnt_aut > 1) cap += '/' + cnt_aut
              cls = 'order2'
            } else {
              cap = ord[0].author.name
              if (Rights.urAdmin || Rights.urOrder) cap += ' ' + sum_aut.toFixed(2)
              cls = 'order1'
              status = 0
            }
            br = <br />
            if (cap && cap.length * 6.8 - 2 > w) {
              if (cap.includes(' ')) {
                r_c++
                const words = cap.split(' ')
                if (words[0].length * 8 > w) small_font = true
                if (words[1].length * 8 > w) small_font = true
              } else small_font = true
            }
            p = Math.max(parseInt((h + 4 - 24 * r_c) / 2), 0)
            stl.padding = p + 'px 8px'
            stl2.padding = p - 1 + 'px 9px'
            if (h < 24 * r_c) stl.lineHeight = parseInt((h + 4) / r_c) + 'px'
            if (small_font) {
              stl.fontSize = 'small'
              stl2.fontSize = 'small'
              stl.padding = p + 'px 3px'
              stl2.padding = p - 1 + 'px 3px'
              if (ord_aut.length > 1) { stl.width = (w + 9) + 'px'; stl2.width = (w + 9) + 'px'; }
            }
          } else status = 0
        }

        let ico = null
        if (status === 1) ico = <div style={{ display: 'inline-block', width: '24px', height: '24px', margin: '-2px 0px -5px 3px', backgroundColor: 'var(--tbl1-tx-color)', mask: 'url(' + icon + '#btn4)' }}></div>
        if (ord_aut.length === 1) return (<Btn key={idx} disabled={cantClick} Cls={cls} Stl={stl} cont={comm} btnClick={() => { tblClick(ord_aut[0]) }} dblClick={() => { tblClick(obj2) }}>{el.name}{br}{cap}{ico}</Btn>)
        else if (ord_aut.length > 1) {
          let menuData = []
          ord_aut.forEach(el => menuData.push({ name: localestr('Замовлення') + ' №' + el.id + ' ' + el.sum, action: () => { tblClick(el) } }))
          menuData.push({ name: localestr('Нове замовлення'), action: () => { tblClick(obj2) } })
          return (<div key={idx} style={stl1}><Menu data={menuData}><Btn Cls={cls} Stl={stl2} cont={comm} btnClick={() => { }} dblClick={() => { tblClick(obj2) }}>{el.name}{br}{cap}{ico}</Btn></Menu></div>)
        } else return (<Btn key={idx} disabled={cantClick} Cls={cls} Stl={stl} cont={comm} btnClick={() => { tblClick(obj) }} dblClick={() => { tblClick(obj2) }}>{el.name}{br}{cap}{ico}</Btn>)
      })
    } else {
      const stl1 = { width: '110px', height: '60px', display: 'table', padding: '4px' }
      const stl2 = { display: 'table-cell', verticalAlign: 'middle', whiteSpace: 'pre-wrap' }
      const ord = Orders.filter(o => o.table && parseInt(o.table.id) === 8000 + parseInt(el.id))
      content = ord.map((el, idx) => {
        let cap = ''
        let cls = ''
        let cantClick = false
        let status = 1
        if (el.author.id === userId) {
          cap += el.sum.toFixed(2)
          cls = 'order'
          if (el.online) cls = 'order2'
          if (!el.status) status = 0
        } else {
          if (!Rights.urAdmin && !Rights.urOrder) cantClick = true
          cap += el.author ? el.author.name : ''
          cls = 'select'
          status = 0
        }
        let ico = null
        if (status === 1) ico = <div style={{ display: 'inline-block', width: '24px', height: '24px', margin: '-2px 0px -5px 3px', backgroundColor: 'var(--tbl1-tx-color)', mask: 'url(' + icon + '#btn4)' }}></div>

        if (cantClick) return (<div key={idx} style={stl1}><div className={'button ' + cls} style={stl2}>{cap}{ico}</div></div>)
        else return (<div key={idx} style={stl1}><div className={'button ' + cls} style={stl2} onClick={() => { console.log('tblClick called with:', el, 'at line 124'); tblClick(el) }}>{cap}{ico}</div></div>)
      })
      if (!content) content = []
      content.push(<div key={content.length} style={stl1}><div className='button' style={stl2} onClick={() => { console.log('tblClick called with:', { table: { id: 8000 + parseInt(el.id), name: '', owner: { ...el } } }, 'at line 126'); tblClick({ table: { id: 8000 + parseInt(el.id), name: '', owner: { ...el } } }) }}>{localestr('Нове замовлення')}</div></div>)
    }
  }

  let header = ''
  let halls = []
  if (Data !== undefined && Data.lenght !== 0) halls = Data.filter(el => el.marked !== '1')
  if (halls.length && (Rights.urAdmin || Rights.urHall)) header = <div>{halls.map((el, idx) => { if (el.id === hall) setCurHall(el); return (<Btn key={idx} disabled={el.id === hall} Cls={el.id === hall ? ('select') : ('')} Stl={{ minWidth: '42px' }} btnClick={() => { setHall(el.id) }}>{el.name}</Btn>) })}</div>
  else if (halls.length) {
    let curHall = null
    if (hall) curHall = halls.find(el => el.id === hall)
    if (!curHall) curHall = halls[0]
    setCurHall(curHall)
  }

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      {header}
      <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }} ref={targetRef}>{content}</div>
    </div>
  )
}

export default TablesTab